import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";

const curriculumData = [
  {
    title: "Web Foundations & Essential Tools",
    description:
      "Web Basics & Developer Tools,  Internet fundamentals, HTML5/CSS3 essentials, Responsive design, Developer tools, Git & GitHub, VS Code mastery.",
  },
  {
    title: "Modern JavaScript & Logic Building",
    description:
      "JavaScript Programming, JavaScript core concepts, flexbox, DOM & events, ES6+ features, Async JS (Promises, Async/Await), API handling, Debugging techniques.",
  },
  {
    title: "Frontend Engineering with React.js",
    description:
      "Frontend with React.js, React basics & JSX, Components & state, Hooks, React Router, API integration, UI architecture.",
  },
  {
    title: "Backend Engineering with Node.js & Express",
    description:
      "Backend with Node.js & Express, Node.js fundamentals, Express.js API building, Middleware & routing, JWT authentication, Database integration, Backend security.",
  },
   {
    title: "Complete Full Stack Integration",
    description:
      " Full Stack Integration, Connecting frontend & backend, Data flow & APIs, User auth implementation, Form handling, Redux/Context.",
  },
   {
    title: "Deployment, Optimization & DevOps Essentials",
    description:
      "Advanced Features & DevOps, Cloud deployment, CI/CD basics, GitHub Actions, API testing with Postman, Performance enhancement, Package management. ",
  },
  {
    title: "Real-World Capstone Project Development",
    description:
      "Capstone Development, Project planning, UI/UX wireframes, Full-stack development, Testing & debugging, Deployment,  Documentation.",
  },
 
  {
    title: "Portfolio Building & Career Launchpad",
    description:
      "Portfolio & Career Prep, Portfolio creation, GitHub structuring, Resume writing, LinkedIn optimization, Mock interview sessions, Career roadmap.",
  },
 
//   {
//     title: "Debugging & Optimization",
//     description:
//       "Error handling, logging, code refactoring, performance improvement.",
//   },
//   {
//     title: "Final Capstone Project",
//     description:
//       "Create professional real-world level project with best practices.",
//   },
];

const ProgramCurriculum = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="curriculum-container">
      <motion.h2
        className="curriculum-heading"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Program Curriculum
      </motion.h2>

      <motion.p
        className="curriculum-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        This curriculum is structured in a practical and progressive format so
        you can learn step-by-step from zero to advanced level — and build
        real-world applications.
      </motion.p>

      <div className="curriculum-list">
        {curriculumData.map((item, index) => (
          <motion.div
            key={index}
            className="curriculum-item"
            onClick={() => toggleSection(index)}
            whileHover={{ x: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="title-row">
              <span className="curriculum-title">{item.title}</span>
              <motion.span
                animate={{ rotate: activeIndex === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="arrow"
              >
                ➤
              </motion.span>
            </div>

            <AnimatePresence>
              {activeIndex === index && (
                <motion.p
                  className="curriculum-description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCurriculum;
